import script from "./FeedbackView.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackView.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackView.vue?vue&type=style&index=0&id=2006f340&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2006f340"]])

export default __exports__